import { isCPF } from 'validation-br';

export const isValidOptionalCpf = (value?: string | null) => {
  if (!value?.trim()) return true;
  return isCPF(value);
};
